import React from 'react';
import { CTAButton } from '../CTAButton';
import { Check, Lock, Package, Star } from 'lucide-react';
export function FinalClose() {
  return <div className="space-y-8" data-id="element-64">
      <h2 className="text-3xl font-bold text-gray-900" data-id="element-65">
        How Much Longer Will You Struggle With Skincare That Doesn't Work?
      </h2>
      <p className="text-xl text-gray-800 leading-relaxed" data-id="element-66">
        ...When there's a solution specifically designed for the aging skin
        challenges women over 50 face?
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-67">
        The way I see it—you really have 2 options:
      </p>
      <div className="bg-gray-50 border-2 border-gray-300 rounded-lg p-6 space-y-4" data-id="element-68">
        <h3 className="text-2xl font-bold text-gray-900" data-id="element-69">Option #1</h3>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-70">
          Continue using traditional skincare products that can't penetrate the
          Permeability Wall.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-71">
          You can keep buying expensive serums that sit on your skin's surface.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-72">
          You can keep wondering why the products that used to work in your 40s
          don't anymore in your 50s and 60s.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-73">
          You can keep watching those fine lines deepen while your skincare
          budget grows.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-74">
          Or you can consider expensive dermatologist treatments at $400-600 per
          session, booking appointments months in advance, dealing with
          downtime.
        </p>
      </div>
      <div className="bg-green-50 border-2 border-green-500 rounded-lg p-6 space-y-4" data-id="element-75">
        <h3 className="text-2xl font-bold text-gray-900" data-id="element-76">
          Or you can try Option #2:
        </h3>
        <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-77">
          The at-home micro-infusion device that has been specifically
          engineered to solve the exact problem women over 50 face.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-78">
          Do what over 100,000 women have done and try this device completely
          risk-free.
        </p>
      </div>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-79">
        It's no coincidence that you've made it all the way to the bottom of
        this article.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-80">
        It means you're ready to try something new.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-81">
        Trust yourself to make the right decision.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-82">
        When you compare these options, it's clear which one makes the most
        sense.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-83">
        So go ahead and tap the button below to claim your device.
      </p>
      <div className="py-4" data-id="element-84">
        <CTAButton variant="secondary" data-id="element-85">GET MY DEVICE NOW (SAVE 64%)</CTAButton>
      </div>
      {/* Trust Badges */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-6" data-id="element-86">
        <div className="flex flex-col items-center text-center space-y-2" data-id="element-87">
          <Check className="w-10 h-10 text-green-600" data-id="element-88" />
          <p className="text-sm font-semibold text-gray-700" data-id="element-89">
            30-Day Money-Back Guarantee
          </p>
        </div>
        <div className="flex flex-col items-center text-center space-y-2" data-id="element-90">
          <Lock className="w-10 h-10 text-blue-600" data-id="element-91" />
          <p className="text-sm font-semibold text-gray-700" data-id="element-92">Secure Checkout</p>
        </div>
        <div className="flex flex-col items-center text-center space-y-2" data-id="element-93">
          <Package className="w-10 h-10 text-purple-600" data-id="element-94" />
          <p className="text-sm font-semibold text-gray-700" data-id="element-95">
            Ships Within 24 Hours
          </p>
        </div>
        <div className="flex flex-col items-center text-center space-y-2" data-id="element-96">
          <Star className="w-10 h-10 text-yellow-600" data-id="element-97" />
          <p className="text-sm font-semibold text-gray-700" data-id="element-98">
            100,000+ Satisfied Customers
          </p>
        </div>
      </div>
    </div>;
}